import { Alert, Button } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";

import { api } from "../api/client";
import { useAuth } from "../auth/AuthProvider";
import { formatDateTime } from "../i18n/format";

/** Shown in the shell while a staff member impersonates a user (CF-0073). */
export function ImpersonationBanner() {
  const { me } = useAuth();
  const qc = useQueryClient();
  const imp = (me as unknown as { impersonation?: { impersonator: string; until: string; allow_writes: boolean; reason: string } | null })?.impersonation;
  if (!imp) return null;
  return (
    <Alert severity="warning" sx={{ borderRadius: 0 }} action={<Button color="inherit" size="small" onClick={async () => { await api.DELETE("/api/v1/console/impersonate/"); qc.clear(); window.location.assign("/console"); }}>Stop</Button>}>
      Viewing as <b>{me?.email}</b> ({imp.allow_writes ? "writes allowed" : "read-only"}) for support: {imp.reason}. Ends {formatDateTime(imp.until)}.
    </Alert>
  );
}
